module.exports = __webpack_public_path__ + "img/lianmeng.362f7a5c.png";